module.exports = __webpack_public_path__ + "img/skip-forward.5088b2c3.svg";